export const inputStyles = {
    width: "100%",
    height: "44px",
    padding: "5px",
    margin: "0px 0",
    borderRadius: "6px",
    border: "1px solid rgba(84, 100, 99, 1)",
};

export const inputStylesOtp = {
    width: "41px",
    height: "44px",
    padding: "15px",
    margin: "0px 0",
    borderRadius: "6px",
    border: "1px solid rgba(84, 100, 99, 1)",
};

export const dateFormat = (date) => {
    const dateObject = new Date(date);

    const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    const dayOfWeek = daysOfWeek[dateObject.getDay()];

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const month = months[dateObject.getMonth()];
    const day = dateObject.getDate();
    const year = dateObject.getFullYear();

    const formattedDate = {
        dayOfWeek: dayOfWeek,
        month: month,
        day: day,
        year: year,
    };
    return formattedDate;
};

export const formattedDate = (date) => {
    return `${date.getFullYear()}-${(
        date.getMonth() + 1
    )
        .toString()
        .padStart(2, "0")}-${date
            .getDate()
            .toString()
            .padStart(2, "0")}`;
};

export const getDatesInMonth = (year, month) => {
    const startDate = new Date(year, month - 1, 1); // month is zero-based
    const endDate = new Date(year, month, 0);

    const dates = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
        const dayName = dateFormat(currentDate).dayOfWeek;
        const day = new Date(currentDate);
        dates.push({
            day: dayName,
            date:
                day.getFullYear() +
                "-" +
                (day.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                day.getDate().toString().padStart(2, "0"),
        });
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
};

export const getNextTenDays = () => {
    const result = [];
    result.push({
        day: dateFormat(new Date()).dayOfWeek,
        date:
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            new Date().getDate().toString().padStart(2, "0"),
    });
    for (let i = 1; i < 10; i++) {
        const date = new Date();
        date.setDate(date.getDate() + i);
        result.push({
            day: dateFormat(date).dayOfWeek,
            date:
                date.getFullYear() +
                "-" +
                (date.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                date.getDate().toString().padStart(2, "0"),
        });
    }
    return result;
};

export const getWholeWeek = (date) => {
    const dateObject = new Date(date);
    const dayOfWeek = dateObject.getDay();
    const firstDayOfWeek = new Date(dateObject);
    firstDayOfWeek.setDate(dateObject.getDate() - dayOfWeek);

    const wholeWeek = [];

    for (let i = 0; i < 7; i++) {
        const day = new Date(firstDayOfWeek);
        day.setDate(firstDayOfWeek.getDate() + i);
        const dayName = dateFormat(day).dayOfWeek;

        wholeWeek.push({
            day: dayName,
            date:
                day.getFullYear() +
                "-" +
                (day.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                day.getDate().toString().padStart(2, "0"),
        });
    }

    return wholeWeek;
};

export function formatDate(dateString) {
    const dateParts = dateString.split('-');
    if (dateParts.length !== 3) {
        return 'Invalid date';
    }
    const [year, month, day] = dateParts;
    return `${day}/${month}/${year}`;
}
export function createOption({ label, value, color, image, name }) {
    return {
        label: label,
        value: value ?? label,
        color: color ?? label,
        image: image ?? "",
        name: name,
    };
}

export const compareWithCurrentDateTime = (date1, time1) => {
    // Create a Date object for the current date and time
    let currentDate = new Date();

    // Create a Date object for the given date
    let givenDate = new Date(date1);

    // Extract hours and minutes from the current time
    let currentHours = currentDate.getHours();
    let currentMinutes = currentDate.getMinutes();

    // Convert the given time (6:30 PM) to 24-hour format (18:30)
    let time = convertTo24HourFormat(time1); // Convert time to 24-hour format
    let givenHours = parseInt(time.split(":")[0]);
    let givenMinutes = parseInt(time.split(":")[1]);

    // Compare the current date with the given date
    if (currentDate.getFullYear() > givenDate.getFullYear()) {
        return false; // Current year is after the given year
    } else if (currentDate.getFullYear() < givenDate.getFullYear()) {
        return true; // Current year is before the given year
    } else if (currentDate.getMonth() > givenDate.getMonth()) {
        return false; // Current month is after the given month
    } else if (currentDate.getMonth() < givenDate.getMonth()) {
        return true; // Current month is before the given month
    } else if (currentDate.getDate() > givenDate.getDate()) {
        return false; // Current day is after the given day
    } else if (currentDate.getDate() < givenDate.getDate()) {
        return true; // Current day is before the given day
    } else {
        // Dates are the same, compare times
        if (currentHours > givenHours || (currentHours === givenHours && currentMinutes >= givenMinutes)) {
            return false; // Current time is after or equal to the given time
        } else {
            return true; // Current time is before the given time
        }
    }
};

// Function to convert time to 24-hour format
const convertTo24HourFormat = (time12h) => {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
        hours = '00';
    }

    if (modifier === 'PM') {
        hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
};

export function addMinutesToTime(time, minutesToAdd) {
	if (!time || !minutesToAdd) return;

	let [hourStr, minuteStr] = time.split(":");
	let hour = parseInt(hourStr);
	let minute = parseInt(minuteStr);
	let minuteAMPM = minuteStr.match(/[APMapm]{2}/)[0];
	minuteStr = minuteStr.replace(minuteAMPM, '');

	if (minuteAMPM.toUpperCase() === "PM" && hour !== 12) {
		hour += 12;
	} else if (minuteAMPM.toUpperCase() === "AM" && hour === 12) {
		hour = 0;
	}

	let newMinute = minute + minutesToAdd;
	hour += Math.floor(newMinute / 60);
	newMinute %= 60;
	hour %= 24;
	if (hour === 0) {
		minuteAMPM = "AM";
		hour = 12;
	} else if (hour === 12) {
		minuteAMPM = "PM";
	} else if (hour > 12) {
		minuteAMPM = "PM";
		hour -= 12;
	} else {
		minuteAMPM = "AM";
	}
	const formattedHour = String(hour).padStart(2, "0");
	const formattedMinute = String(newMinute).padStart(2, "0");

	return `${formattedHour}:${formattedMinute} ${minuteAMPM}`;
}